import { Button } from '@/components/Button/Button'
import { GeneratorPopup } from '@/components/Generator/GeneratorPopup/GeneratorPopup'
import { Loader } from '@/components/Loader/Loader'
import { Message } from '@/components/Message/Message'
import { useInView } from '@/hooks/useInView'
import { PostItem } from '@/pages/PostsPage/PostItem/PostItem'
import { usePostsState } from '@/state/posts'
import { format } from 'date-fns'
import groupBy from 'lodash.groupby'
import type { FunctionalComponent } from 'preact'
import { useMemo, useState } from 'preact/hooks'
import styles from './index.module.scss'

export const PostsPage: FunctionalComponent<{
  path?: string
}> = () => {
  const posts = usePostsState(s => s.list)
  const hasMore = usePostsState(s => s.hasMore)
  const fetchMore = usePostsState(s => s.fetchMore)
  const grouped = groupBy(posts, post => format(new Date(post.createdAt), 'MMM d, yyyy'))

  const [generatorVisible, setGeneratorVisible] = useState(false)

  const loading = usePostsState(s => s.loading)
  const empty = usePostsState(s => s.empty)
  const entries = useMemo(() => (
    Object.entries(grouped).filter(([_, posts]) => posts.length > 0)
  ), [grouped])

  const ref = useInView(
    () => {
      fetchMore()
    },
    hasMore && !loading,
  )

  return (
    <>
      {generatorVisible && (
        <GeneratorPopup
          onClose={() => {
            setGeneratorVisible(false)
          }}
        />
      )}

      <div class={styles.root}>
        {entries.length === 0 && loading
          ? (
            <Message>
              Loading <Loader />
            </Message>
          )
          : entries.length === 0 && empty
          ? (
            <Message>
              <div>
                No posts yet.
              </div>
              <div>
                Generate your first post from commits and start building in public.
              </div>
              <div>
                <Button
                  type='primary'
                  onClick={() => {
                    setGeneratorVisible(true)
                  }}
                >
                  make post
                </Button>
              </div>
            </Message>
          )
          : (
            entries.map(([date, posts]) => (
              <div key={date}>
                <h3 class={styles.date}>{date}</h3>

                <div class={styles.posts}>
                  {posts.map(posts => (
                    <PostItem
                      postId={posts.id}
                    />
                  ))}
                </div>
              </div>
            ))
          )}

        {hasMore && (
          <div
            ref={ref}
            class={styles.more}
          >
            {loading
              ? (
                <>
                  Loading <Loader />
                </>
              )
              : null}
          </div>
        )}
      </div>
    </>
  )
}
